import React, { useState, useEffect } from 'react';
import { Flex, Text, Grid, Tooltip, Button, Select } from '@radix-ui/themes';
import { CubeIcon } from '@radix-ui/react-icons';
import { useEdges } from 'reactflow';

import { NodeInput, TemplateBuilder } from '../../../inputs';
import { WorkflowNodeProps } from '../..';
import * as Types from '../../../../../types';

enum LLMProvider {
  OpenAI = 'OPENAI',
  Anthropic = 'ANTHROPIC',
}

const LLMCallNode = ({
  id,
  data,
  onChange,
}: WorkflowNodeProps<Types.TransformerNode>) => {
  const edges = useEdges();

  const hasMessageEdge = edges.some(
    (edge) => edge.target === id && edge.targetHandle === 'prompt',
  );

  return (
    <Flex direction="column" gap="1">
      <Flex align="center" gap="2" mb="2">
        <CubeIcon />
        <Text as="div" size="2" weight="bold">
          LLM Call
        </Text>
      </Flex>
      <Grid columns="1" gap="3">
        <NodeInput title="Provider">
          <Select.Root value={LLMProvider.OpenAI} onValueChange={() => {}}>
            <Select.Trigger />
            <Select.Content>
              {Object.entries(LLMProvider).map(([key, value]) => (
                <Select.Item key={key} value={value}>
                  {key}
                </Select.Item>
              ))}
            </Select.Content>
          </Select.Root>
        </NodeInput>
        <NodeInput title="Prompt">
          <TemplateBuilder content={''} onChange={() => {}} isEditing={true} />
        </NodeInput>
      </Grid>
    </Flex>
  );
};

export default LLMCallNode;
